export default "__VITE_ASSET__wONAgXVdu70nIscqnESwQA__"